'use strict';

exports.__esModule = true;

var _react = require('react');

exports['default'] = {
  cellblock: _react.PropTypes.bool,
  cellblockGet: _react.PropTypes.func,
  cellblockColumn: _react.PropTypes.object,
  cellblockBreak: _react.PropTypes.number // purely to identify staleness
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cellblock/lib/util/context.js
// module id = 114
// module chunks = 0